(() => {
  const LABELS = {
    'watch-field-1': 'Line 1',
    'watch-field-2': 'Line 2'
  };

  function updateLabels(root = document) {
    const nodes = root.querySelectorAll ? root.querySelectorAll('label, p, span, div') : [];
    nodes.forEach((el) => {
      const text = (el.textContent || '').trim();
      if (LABELS[text] && el.children.length === 0) {
        el.textContent = LABELS[text];
      }
    });

    const inputs = root.querySelectorAll ? root.querySelectorAll('input') : [];
    const secondInput = Array.from(inputs).find((input) => {
      const name = input.getAttribute('name') || '';
      const id = input.getAttribute('id') || '';
      return name.includes('watch-field-2') || id.includes('watch-field-2');
    });

    if (secondInput) {
      const container = secondInput.closest('div');
      if (container && !container.parentElement?.querySelector('[data-hfk-engraving-note]')) {
        const note = document.createElement('p');
        note.dataset.hfkEngravingNote = 'true';
        note.textContent = 'Up to 20 characters per line. Please double-check spelling before adding to cart.';
        note.style.margin = '8px 0 0';
        note.style.fontSize = '0.875rem';
        note.style.lineHeight = '1.4';
        note.style.opacity = '0.75';
        container.insertAdjacentElement('afterend', note);
      }
    }
  }

  updateLabels();

  const observer = new MutationObserver(() => updateLabels());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();